// extracted by mini-css-extract-plugin
module.exports = {"container":"e_4i","hasBadge":"e_5i","bottomLine":"e_6i","imageContainer":"e_7i","image":"e_8i","header":"e_9i","title":"e_-i","score":"e_aj"};